// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","664":"reactPlayerPreview","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"230":"0e4c631cfd4abef1c49f","664":"f297836689ba847cfe94","731":"d826c680c40e8e8437e1","843":"fab5d6a28c24ee9e17da","883":"ea1427ddff65b8a589b0"}[chunkId] + ".js";
};